import { Container } from "@mui/material";

export const Body = ({ children }) => {
  return (
    <Container
      maxWidth="lg"
      sx={{ minHeight: "calc(100vh - 150px)", py: { xs: 4, md: 8 } }}
    >
      {children}
    </Container>
  );
};
